import { ForwardedRef, forwardRef } from 'preact/compat';

import MobileMediaCard from '../MediaCollectionView/MobileMediaCard';
import { usePlaylistState } from './hooks';
import { PlaylistProps, PlaylistRef } from './types';

const Playlist = (
  { playlistIdFromURL, videoIdFromURL, className, play, onVideoChange, onVideoClick }: PlaylistProps,
  ref: ForwardedRef<PlaylistRef>,
) => {
  const { data, videoIndex, videoChangeHandler } = usePlaylistState({
    playlistIdFromURL,
    videoIdFromURL,
    play,
    onVideoChange,
    onVideoClick,
    ref,
  });

  return (
    <div className={className}>
      <ul className="preflight preflight-ul space-y-6">
        {data?.videos.map((video, index) => (
          <li key={video._id} className="scroll-m-2">
            <a
              data-native
              className="preflight preflight-a group relative grid grid-cols-[150px_1fr] gap-4 transition-opacity hover:opacity-80 aria-disabled:opacity-50"
              href={`/highlights?type=highlight&playlistId=${data._id}&videoId=${video._id}`}
              aria-disabled={video.disabled}
              onClick={(e) => {
                e.preventDefault();
                videoChangeHandler(video, index);
                onVideoClick?.(video, index);
              }}
            >
              <MobileMediaCard video={video} isPlaying={videoIndex === index} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default forwardRef(Playlist);
